import {useState, useEffect, useRef} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {useTranslation} from "react-i18next";
import {profileActions, questionnaireActions} from "_actions";
import * as _ from 'lodash';
import {history} from '_helpers/history'
import {Space, Button, Modal, Radio, Checkbox, Select, Divider} from 'antd';
import {LeftOutlined} from "@ant-design/icons";
import {useLocation} from "react-router-dom";
import variables from "../../../../_constants/variables";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";
import Headerbutton from "../../component/headerButton";
import SliderV from "../../../../components/Slider/SliderV";
import {Option} from "antd/es/mentions";
import {xcService} from "../../../../_services/xcService";
import comunidades from "../../../../_constants/comunidades";
import item1 from "../../../../assets/img/caja.png";

function StartTekPage(props) {

    const dispatch = useDispatch();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t} = useTranslation();
    const [init, setInit] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const location = useLocation();
    const [restartQuestions, setRestartQuestions] = useState(new URLSearchParams(location.search).get('restart') === 'true');
    const [touch, setTouch] = useState(false);
    const [step, setStep] = useState(-1);
    const [, setSubStep] = useState(-1);
    const [data, setData] = useState(null);
    const [assessment, setAssessment] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [value, setValue] = useState(null)
    const [showModal, setShowModal] = useState(false);
    const [valueOb, setValueOb] = useState(null);
    const [degreeData, setDegreeData] = useState([]);
    const [currentFpb, setCurrentFpb] = useState();
    const [userQuest, setUserQuest] = useState();
    const [subjectOptions, setSubjectOptions] = useState();
    const [subjectData, setSubjectData] = useState();
    const [notDoCheckbox, setNotDoCheckbox] = useState(false);
    const [modality, setModality] = useState(null);
    const [modality2, setModality2] = useState(null);
    const [modality3, setModality3] = useState(null);
    const [modality4, setModality4] = useState(null);
    const [degreeFamily, setDegreeFamily] = useState();
    const [valueArray, setValueArray] = useState([]);
    const [currentAvatarStep,setCurrentAvatarStep] = useState("TEK_AVATAR_1");

    const setQuest = (course) => {
        const quests = {
            '3º ESO': 'TEK3ESO',
            '4º ESO': 'TEK4ESO',
            '1º Bachillerato': 'TEK1BAC',
            '2º Bachillerato': 'TEK2BAC',
            'FP Grado Básico': 'TEKFPB',
            'FP Grado Medio': 'TEKFPM',
        }
        setUserQuest(quests[course])
    }

    useEffect(() => {
        if (!userQuest) return;
        dispatch(questionnaireActions.getAssessmentsCode(userQuest))
        dispatch(questionnaireActions.getAnswers(userQuest))

        dispatch(profileActions.getItems())
    }, [userQuest])

    function onChange(value) {

        setDisabled(false);
        setTouch(true)
        if (Array.isArray(value)) {
            setValue(value[0])
        } else {
            setValue(value)
        }
    }

    var assestmentsCodeData = useSelector((state) => state.questionnaireReducer.assestmentsCodeData);
    var saveAnswer = useSelector((state) => state.questionnaireReducer.saveAnswer);
    var answersData = useSelector((state) => state.questionnaireReducer.answersData);
    var answersDataError = useSelector((state) => state.questionnaireReducer.answersDataError);
    var responsesData = useSelector((state) => state.questionnaireReducer.responsesData);
    var studentArea = useSelector((state) => state.questionnaireReducer.getStudentArea);

    useEffect(() => {
        if (answersData) {

            localStorage.removeItem(variables.LASTTEK);
            setAnswers(answersData);
            if (data && data.length) {

                if (answersData.length === data.length && !restartQuestions) {
                    history.push("/admin/finish-tek")
                } else {
                    setValueOb(null);

                    if (step + 1 === (data.length)) {
                        setDisabled(true);
                        setTouch(false);
                        setValue(null)
                        setAssessment(data[0])
                        setStep(0);
                        setSubStep(1);
                        setValueOb(null);
                    } else {
                        setDisabled(true);
                        setTouch(false);
                        setValue(null)
                        setAssessment(data[step + 1])
                        setStep(step + 1);
                        setSubStep(1);
                        setValueOb(null);
                    }
                }
            }
        }
    }, [answersData, answersDataError])

    useEffect(() => {
        if (["SINGLE", "MULTIPLE", "MULTIPLE4", "MULTIPLE3", "MULTIPLE2"].includes(assessment?.questionType)) dispatch(questionnaireActions.getResponses(assessment.id))
    }, [assessment]);

    const goBack = () => {
        if (step === 0){
            history.push("/admin/tek-instructions")
        }else{
            setDisabled(true);
            setTouch(false);
            setValue(null)
            setAssessment(data[step - 1])
            setStep(step - 1);
            setSubStep(1);
            setValueOb(null);
        }
    }

    function onlyUnique(value, index, self) {
        return self?.indexOf(value) === index;
    }

    useEffect(() => {

        dispatch(questionnaireActions.getArea())
        dispatch(profileActions.getItems());
        Promise.all(['FPB', 'CFGM', 'CFGS', 'UNIV'].map(code => xcService.getToken(`/v1/degree/${code}`)))
            .then(res => setDegreeData(res.map(({data}) => data.data).flat()))

        xcService.getToken('/v1/student/course')
            .then(({data}) => {
                setQuest(data.data.name)
                return data;
            })
            .then(({data}) =>
                xcService.getToken(`/v1/subjects/${data.name === '4º ESO' ? '4ESO' : data.name === '2º Bachillerato' ? '2BAC' : '1BAC'}`)
            ).then(({data}) => {
            const modalities = data.data.map(subject => subject.modality)
                .filter(onlyUnique)
            setSubjectOptions(modalities)
            setSubjectData(data.data)
            //const tree = data.
        })
    }, []);


    useEffect(() => {
        if (assestmentsCodeData) {

            setAssessment(assestmentsCodeData[0])
            setData(assestmentsCodeData);

            if (new URLSearchParams(location.search).get('inStep')){
                let mStep =(+new URLSearchParams(location.search).get('inStep'))-1
                setStep(mStep);
            }else{
                const lastTek = localStorage.getItem(variables.LASTTEK);
                setStep(lastTek && +lastTek > 0 ? +lastTek : -1);
            }

            setSubStep(1);
        }
    }, [assestmentsCodeData]);

    const Continue = () => {
        setShowModal(false)
    }

    useEffect(() => {
        let mNext = true;
        if (saveAnswer) {
            setDegreeFamily(null);
            setCurrentFpb(null);
            setModality(null);
            setModality2(null);
            setModality3(null);
            setModality4(null);

            if (assessment && assessment.avatarGroup) {
                dispatch(profileActions.saveItem({
                    groupName: assessment.avatarGroup,
                    callback: (status, data) => {
                        if (status === "saved") {
                            setCurrentAvatarStep(assessment.avatarGroup);
                            setShowModal(true);
                        } else if (status === "already_saved") {
                            setCurrentAvatarStep(assessment.avatarGroup);
                        }
                    }
                }))
            }


            const newList = answers.map(ans => {
                if (ans.assessment_id === assessment.id) {
                    return {...ans, points: value};
                }
                return {...ans};
            });
            let mKk = null;
            if (assessment) {
                mKk = _.find(answers, {assessment_id: assessment.id});
            }
            if (mKk) mKk.points = value
            setAnswers(newList);

            if (new URLSearchParams(location.search).get('inStep')){
                history.push("/admin/finish-tek")
            }
            if (mNext) dispatch(questionnaireActions.getAnswers(userQuest))
        }
    }, [saveAnswer])

    useEffect(() => {
        if (step !== -1) {
            let mValue = _.filter(answers, function (o) {
                return o.assessment_id === assessment.id && o.isActive;
            });
            if (mValue && mValue[0]) {

                setValueArray([])

                if (mValue[0].assessment.questionType === 'MULTIPLE3'
                    || mValue[0].assessment.questionType === 'MULTIPLE2'
                    || mValue[0].assessment.questionType === 'MULTIPLE4'){
                    let mResult = mValue[0].subanswers.map(item =>  item.points);

                    setValueArray(mResult);
                }
                if (mValue[0].assessment.questionType === 'UNIV'
                    || mValue[0].assessment.questionType === 'FPB'
                    || mValue[0].assessment.questionType === 'CFGM'
                    || mValue[0].assessment.questionType === 'CFGS'  || mValue[0].assessment.questionType === 'SUBJECT') {


                    if (mValue[0].points === 999){
                        setNotDoCheckbox(true);
                    }
                }

                if (mValue[0].isDegree && mValue[0].degree){
                    if (mValue[0].assessment.questionType === 'UNIV'){
                        setDegreeFamily(mValue[0].degree.family)
                    }else{
                        setCurrentFpb(mValue[0].degree.family)
                    }
                    setTouch(true)
                    setValue(mValue[0].degree_id);

                }else if (mValue[0].modality_id && mValue[0].subject) {


                    setModality(mValue[0].subject.modality);
                    setModality2(mValue[0].subject.id);
                    if (mValue[0].subanswers.length) {
                        setModality3([mValue[0].subanswers[0]?.points, mValue[0].subanswers[1]?.points])
                    }

                    if (mValue[0].subanswers[2]) {
                        setModality4( mValue[0].subanswers[2]?.points)
                    }


                }else {
                    setValue(mValue[0].points ?? -1);
                    if (mValue[0].points) {
                        setTouch(true)
                    } else {
                        setTouch(false)
                    }
                }

                setValueOb(mValue[0].assessment.questionType === "RATINGOB" ? mValue[0].yesno  : null);
                if (mValue[0].yesno) {
                    setTouch(true)
                }
                setDisabled(false)
            }
        }
    }, [step])

    const saveResponse = () => {

        if (assessment.questionType !== "SUBJECT"){
            setModality(null);
            setModality2(null);
            setModality3(null);
            setModality4(null);
        }
        if (modality4 && assessment.questionType === "SUBJECT") {

            xcService.postToken("/v1/student/assessments/answer", {
                yesno: valueOb,
                points: modality2,
                isModality: true,
                isDegree: false,
                assessment_id: assessment.id
            }).then((dataR) => {


                let mSubAnswers = modality3;
                mSubAnswers.push(modality4);
                xcService.postToken("/v1/student/assessments/subanswer", {
                    responses: mSubAnswers,
                    answer_id: dataR.data.data.id,
                    assessment_id: assessment.id
                }).then(data => {
                    dispatch(questionnaireActions.saveFakeAnswer({
                        points: modality4,
                        answer_id: dataR.data.id,
                        assessment_id: assessment.id
                    }))
                })


            })
        } else {
            if (notDoCheckbox) {
                dispatch(questionnaireActions.saveAnswer({
                    isModality: false,
                    isDegree: false,
                    yesno: 0,
                    points: 999,
                    assessment_id: assessment.id
                }))
                setNotDoCheckbox(false);
            } else {
                if (touch || (valueOb === 0)) {

                    setTouch(false);
                    if (assessment.questionType === 'MULTIPLE3'
                        || assessment.questionType === 'MULTIPLE2'
                        || assessment.questionType === 'MULTIPLE4'){

                        xcService.postToken("/v1/student/assessments/answer", {
                            yesno: valueOb,
                            points: valueArray[0],
                            isModality: false,
                            isDegree: false,
                            assessment_id: assessment.id
                        }).then((dataR) => {


                            xcService.postToken("/v1/student/assessments/subanswer", {
                                responses: valueArray,
                                answer_id: dataR.data.data.id,
                                assessment_id: assessment.id
                            }).then(data => {
                                dispatch(questionnaireActions.saveFakeAnswer({
                                    points: valueArray[0],
                                    answer_id: dataR.data.id,
                                    assessment_id: assessment.id
                                }))
                            })
                        });
                    }else {
                        dispatch(questionnaireActions.saveAnswer({
                            isModality: false,
                            isDegree: assessment.questionType === 'FPB' || assessment.questionType === 'CFGM' || assessment.questionType === 'CFGS' || assessment.questionType === 'UNIV' ? true : false,
                            yesno: valueOb,
                            points: valueOb === 0 ? 0 : value,
                            assessment_id: assessment.id
                        }))
                    }

                }
            }
        }
        if (step === data.length - 1) setRestartQuestions(null);
    }


    const onChangeNotDoCheckbox = (e) => {

        setNotDoCheckbox(e.target.checked)

        if (assessment.questionType === "SUBJECT"){
            setModality(null);
            setModality2(null);
            setModality3(null);
            setModality4(null);
            setDisabled(false);
        }
        setDisabled(false);
    }

    const start = () => {
        setInit(false);
        const lastTek = localStorage.getItem(variables.LASTTEK);
        if (lastTek && +lastTek > 0) {
            setAssessment(data[lastTek])
            setStep(+lastTek);
        } else {
            setAssessment(data[0])
            setStep(0);
        }

        setValueOb(null);
    }

    const onChangeRadio = (e) => {

        setValueOb(e.target.value);

        if (!e.target.value) {
            setDisabled(false);
            setTouch(true)
        }
        if (e.target.value && value < 1) {
            setDisabled(true);

        } else {
            setDisabled(false);
        }
    };



    function onChangeMultiple3(value) {
        if (value.length < 3){
            setValueArray(value)
            setDisabled(true);
            setTouch(true)
        }
        if (value.length === 3) {
            setValueArray(value)
            setDisabled(false);
            setTouch(true)


            if (Array.isArray(value)) {
                setValue(value[0])
            } else {
                setValue(value)
            }
        }
    }



    function onChangeMultiple4(value) {
        if (value.length < 4){
            setValueArray(value)
            setDisabled(true);
            setTouch(true)
        }
        if (value.length === 4) {
            setValueArray(value)
            setDisabled(false);
            setTouch(true)


            if (Array.isArray(value)) {
                setValue(value[0])
            } else {
                setValue(value)
            }
        }
    }


    function onChangeMultiple2(value) {
        if (value.length < 2){
            setValueArray(value)
            setDisabled(true);
            setTouch(true)
        }
        if (value.length === 2) {
            setValueArray(value)
            setDisabled(false);
            setTouch(true)


            if (Array.isArray(value)) {
                setValue(value[0])
            } else {
                setValue(value)
            }

        }


    }

    const changeModality1 = (value) => {

        setModality(value.target.value);
        setModality2(null);
        setModality3(null);
        setModality4(null);
        setDisabled(true);
    }
    const changeModality2 = (value) => {

        setModality2(value.target.value);
        setModality3(null);
        setModality4(null);
        setDisabled(true);
    }

    const changeModality3 = (value) => {

        if (value.length < 3) {
            if (value.length > 0) {
                setModality3(value);
                setModality4(null);
                setDisabled(true);
            }
        }
    }
    const changeModality4 = (value) => {

        setModality4(value.target.value);
        setDisabled(false)

    }
    const saveAndContinue = () => {
        localStorage.setItem(variables.LASTTEK, step -1);
        history.push("/admin/assessment")
    }

    const isDisabledCheck = (subject) => {
        let  mRet = false;
        let mSelected = subjectData.filter(subject => subject.order === 1 && subject.id === modality2)

        if (mSelected && mSelected[0]){
            if (mSelected[0].subject.trim().toLowerCase() === subject.subject.trim().toLowerCase()){
                mRet = true;
            }
        }
        return mRet;
    }

    return (assestmentsCodeData ? <p>Loading...</p> :
            <div className={"backGroundCeiba"}>
                <Modal className={"modalName modal-question modal-question--xs"} title={t(`tek.${currentAvatarStep}.elemento`)} visible={showModal} onOk={Continue}
                       onCancel={Continue}>
                    <div className={"diNombre"}>
                        <div className={"titleInfo"}>
                            {t(`tek.${currentAvatarStep}.conseguidoagua1`, {nombre: user.name})}
                            <br/>
                            {t(`tek.${currentAvatarStep}.conseguidoagua2`)}

                        </div>

                        <div className={"elemento"}>
                            <img src={item1}/>
                        </div>

                        <Button style={{marginTop: 20}} type={"primary"} onClick={() => Continue()}
                                className="primaryButton buttonSizeO center-text">{t("continuar")}</Button>

                    </div>
                </Modal>


                <div className={"wrapper-question boxed"}>
                    <div className={"insideCeiba boxed"}>
                        <Headerbutton saveAndContinue={saveAndContinue} title={t("tek.header")}/>
                    </div>
                    {init &&
                        <>

                            <div className={"container-pre-question boxed"}>
                                <div className={"content-pre-question"}>
                                    <div className={"content-text-scroll"}>
                                        <p className={"pre-question-title"}>{t("tek.title")}</p>
                                        {/* ToDo : Añadir que aparece el interés preferente del alumno del cuestionario 1*/}
                                        <p className={"pre-question-list"}>{user.name ?? ""},&nbsp;{t('tek.itin1.init1')} </p>
                                        <p className={"pre-question-list"}>{t('tek.itin1.init2')} </p>
                                        <p className={"pre-question-list"}>{t('tek.itin1.init3')} </p>
                                        <p className={"pre-question-list"}>{t("tek.itin1.init4")}</p>
                                        <p className={"pre-question-list"}>{t("tek.itin1.init5")}</p>
                                        <p className={"pre-question-list"}>{t("tek.itin1.init7")}</p>
                                        <p className={"pre-question-list"}>{t("tek.itin1.init8")}</p>
                                    </div>
                                    <Button type={"primary"} onClick={() => start()}
                                            className="primaryButton btn-start">{t("start")}</Button>
                                </div>
                                <Button type="link"
                                        icon={<LeftOutlined/>}
                                        onClick={() => history.push("/admin/assessment")}
                                        className={"btn-back"}

                                >
                                    {t("atras")}
                                </Button>
                            </div>


                        </>

                    }
                    {step !== -1 && !init &&
                        <>

                            <div className={"container-question no-gamificado"}>
                                <div className={"container-question__auto-margin"}>
                                    <div className={"question__header"}>
                                        <h2>{t("tek.title")} </h2>
                                        <span className={"count"}>{+step + 1}/{data.length}</span>
                                    </div>
                                    <div className={"question__content"}>
                                        <div className={"question__content-mid"}>
                                            <div className={"question__content-mid__info"}>
                                                <div className={"question__content-mid__info-l"}>
                                                    <div className={"container-line"}>
                                                        <p className={"container-line__text"}
                                                           dangerouslySetInnerHTML={{__html: t('tek.itin1.info')}}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"question__content-mid__question"}>
                                                <p dangerouslySetInnerHTML={{__html: "<strong>" + assessment.question.replace('{{vocArea}}', studentArea?.area?.name ?? '') + "</strong>"}} />



                                                {assessment.questionType === "RATING" &&
                                                    <>
                                                        <SliderV
                                                            dots={true}
                                                            style={{marginTop: 20}}
                                                            step={1}
                                                            value={value}
                                                            onChange={onChange}
                                                            min={1}
                                                            max={10}
                                                        />
                                                    </>

                                                }
                                                {assessment.questionType === "RATINGOB" &&
                                                    <>
                                                        <Radio.Group onChange={onChangeRadio} value={valueOb}>
                                                            <Space direction="vertical">
                                                                <Radio key="RATINGOB1" value={1}>{t("yes")}</Radio>
                                                                <Radio key="RATINGOB0" value={0}>{t("no")}</Radio>
                                                            </Space>
                                                        </Radio.Group>
                                                        {valueOb === 1 &&
                                                            <>
                                                                <div className={"container-rattion"}>
                                                                    <p><strong>{t("satis")}</strong></p>
                                                                    <SliderV
                                                                        dots={true}
                                                                        style={{marginTop: 20}}
                                                                        step={1}
                                                                        value={value}
                                                                        onChange={onChange}
                                                                        min={1}
                                                                        max={10}/>
                                                                </div>
                                                            </>
                                                        }

                                                    </>
                                                }

                                                {assessment.questionType === "RATING" || valueOb === 1 &&
                                                    <>
                                                        <div className={"content-placeholderrating"}>
                                                            <p className="placeholderrating">
                                                                {valueOb === 1 ? t("muybaja") : t("desacuerdo")}</p>
                                                            <p className="placeholderrating">{valueOb === 1 ? t("muyalta") : t("deacuerdo")}</p>

                                                        </div>
                                                    </>
                                                }

                                                {assessment.questionType === "RATING" && !valueOb &&
                                                    <>
                                                        <div className={"content-placeholderrating"}>
                                                            <p className="placeholderrating">{t("desacuerdo")}</p>
                                                            <p className="placeholderrating">{t("deacuerdo")}</p>
                                                        </div>
                                                    </>
                                                }

                                                {assessment.questionType === "MULTIPLE" && !valueOb && responsesData &&
                                                    <div className={"content-custom-checkbox"}>
                                                        <Checkbox.Group onChange={onChange} options={responsesData
                                                            .map(response => {
                                                                return {
                                                                    label: response.question,
                                                                    value: response.id
                                                                }
                                                            })}>
                                                        </Checkbox.Group>
                                                    </div>
                                                }

                                                {assessment.questionType === "MULTIPLE3" && !valueOb && responsesData &&
                                                    <div className={"content-custom-checkbox"}>


                                                        <Checkbox.Group
                                                            value={valueArray} onChange={onChangeMultiple3} options={responsesData
                                                            .map(response => {
                                                                return {
                                                                    label: response.question,
                                                                    value: response.id
                                                                }
                                                            })}>
                                                        </Checkbox.Group>
                                                    </div>
                                                }

                                                {assessment.questionType === "MULTIPLE2" && !valueOb && responsesData &&
                                                    <div className={"content-custom-checkbox"}>

                                                        <Checkbox.Group
                                                            value={valueArray} onChange={onChangeMultiple2} options={responsesData
                                                            .map(response => {
                                                                return {
                                                                    label: response.question,
                                                                    value: response.id
                                                                }
                                                            })}>
                                                        </Checkbox.Group>
                                                    </div>
                                                }

                                                {assessment.questionType === "MULTIPLE4" && !valueOb && responsesData &&
                                                    <div className={"content-custom-checkbox"}>
                                                        <Checkbox.Group
                                                            value={valueArray} onChange={onChangeMultiple4} options={responsesData
                                                            .map(response => {
                                                                return {
                                                                    label: response.question,
                                                                    value: response.id
                                                                }
                                                            })}>
                                                        </Checkbox.Group>
                                                    </div>
                                                }
                                                {assessment.questionType === "SINGLE" && !valueOb && responsesData &&
                                                    <Radio.Group
                                                        onChange={(value) => onChange(value.target.value)}
                                                        value={value}
                                                        options={responsesData
                                                            .map(response => {
                                                                return {
                                                                    label: response.question,
                                                                    value: response.id
                                                                }
                                                            })}>

                                                    </Radio.Group>
                                                }
                                                {assessment.questionType === "COMAUT" && !valueOb && responsesData &&

                                                    <div className={"content-custom-select"}>
                                                        <p>{t("tek.questionnaire.autcommunity")}</p>
                                                        <Select value={value} onChange={onChange}>
                                                            {comunidades.map(data => <Option key={data.code + data.name}
                                                                                             value={data.code}>{data.name}</Option>)}
                                                        </Select>
                                                    </div>
                                                }
                                                {
                                                    ['FPB', 'CFGM', 'CFGS'].map(degCode =>
                                                        assessment.questionType === degCode &&
                                                        <>
                                                             {userQuest === "TEKFPB" &&
                                                                (assessment.questionType === 'CFGM' || assessment.questionType === 'CFGS') &&
                                                                <Checkbox

                                                                    checked={notDoCheckbox}
                                                                    onChange={onChangeNotDoCheckbox}>
                                                                    <p dangerouslySetInnerHTML={{__html: (t("tek.questionnaire.check" + degCode))}} /></Checkbox>
                                                            }

                                                            {userQuest === "TEKFPM" &&
                                                                ( assessment.questionType === 'CFGS') &&
                                                                <Checkbox

                                                                    checked={notDoCheckbox}
                                                                    onChange={onChangeNotDoCheckbox}><p dangerouslySetInnerHTML={{__html: (t("tek.questionnaire.check" + degCode))}} /></Checkbox>
                                                            }
                                                            { (userQuest === "TEK2BAC" || userQuest === "TEK4ESO"
                                                                    || userQuest === "TEK3ESO"  || userQuest === "TEK1BAC")
                                                                &&
                                                                <Checkbox

                                                                    checked={notDoCheckbox}
                                                                    onChange={onChangeNotDoCheckbox}>
                                                                    <p dangerouslySetInnerHTML={{__html: (t("tek.questionnaire.check" + degCode))}} /></Checkbox>
                                                            }

                                                            <div className={"content-custom-select"}>
                                                                <p>{t("tek.questionnaire.profamily")}</p>


                                                                <select multiple

                                                                        value={[currentFpb]}
                                                                        onChange={({target}) => setCurrentFpb(target.value)}
                                                                        disabled={notDoCheckbox}>
                                                                    {[...new Set(
                                                                        degreeData
                                                                            .filter(data => (data.degree === degCode && data.family  && data.family !== "" ))
                                                                            .map(data => data.family)
                                                                    )].map(family => <option

                                                                        value={family}>{family}</option>)
                                                                    }
                                                                </select>
                                                            </div>
                                                            {currentFpb &&
                                                                <div className={"content-custom-select"}>
                                                                    <p>{t("tek.questionnaire.title")}</p>
                                                                    <select multiple
                                                                            value={[value]}
                                                                            onChange={({target}) => onChange(target.value)}
                                                                            disabled={notDoCheckbox}>
                                                                        {
                                                                            degreeData
                                                                                .filter(data => data.degree === degCode && data.family === currentFpb)
                                                                                .map(data => <option
                                                                                    value={+data.id}>{data.title}</option>)
                                                                        }
                                                                    </select>
                                                                </div>
                                                            }
                                                        </>
                                                    )
                                                }

                                                {
                                                    assessment.questionType === 'UNIV' && <>

                                                        <div className={"content-custom-select"}>
                                                            <Checkbox

                                                                checked={notDoCheckbox}
                                                                onChange={onChangeNotDoCheckbox}><p dangerouslySetInnerHTML={{__html: (t("tek.questionnaire.checkuni"))}} /></Checkbox>

                                                            <div className={"content-custom-select"}>
                                                                <p>{t("tek.questionnaire.areafamily")}</p>


                                                                <select multiple disabled={notDoCheckbox}
                                                                        value={[degreeFamily]}
                                                                        onChange={({target}) => setDegreeFamily(target.value)
                                                                        }>
                                                                    {[...new Set(
                                                                        degreeData
                                                                            .filter(data => (data.degree === 'UNIV' && data.family  && data.family !== ""))
                                                                            .map(data => data.family)
                                                                    )].map(family => <option

                                                                        value={family}>{family}</option>)
                                                                    }
                                                                </select>
                                                            </div>
                                                            <div className={"content-custom-select"}>
                                                                <p>{t("tek.questionnaire.title")}</p>
                                                                <select multiple disabled={notDoCheckbox}
                                                                        value={[value]}
                                                                        onChange={({target}) => onChange(target.value)}>
                                                                    {
                                                                        degreeData
                                                                            .filter(data => data.degree === 'UNIV' && data.family === degreeFamily)
                                                                            .map(data => <option
                                                                                value={data.id}>{data.title}</option>)
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                }

                                                {
                                                    assessment.questionType === 'SUBJECT' && subjectOptions && <>
                                                        <>

                                                            {userQuest !== "TEK1BAC" && userQuest !== "TEK2BAC" &&
                                                                <Checkbox

                                                                    checked={notDoCheckbox}
                                                                    onChange={onChangeNotDoCheckbox}><p
                                                                    dangerouslySetInnerHTML={{__html: (t("tek.questionnaire.checkbtx"))}}/>
                                                                </Checkbox>
                                                            }

                                                            <div
                                                                className={"content-custom-select content-custom-select--vertical"}>

                                                                <span>{t("tek1")}</span>

                                                                <Radio.Group onChange={changeModality1} value={modality}
                                                                             disabled={notDoCheckbox}
                                                                             style={{marginTop: 5, marginBottom: 10}}>
                                                                    <Space direction="vertical">
                                                                        {subjectOptions.map((option, idx) => <Radio
                                                                            key={idx+option} value={option}>{option}</Radio>)}
                                                                    </Space>
                                                                </Radio.Group>
                                                                {
                                                                    modality &&
                                                                    <>
                                                                        <p>{t("tek2")}</p>

                                                                        <Radio.Group style={{marginTop: 5, marginBottom: 10}}
                                                                                     onChange={changeModality2}
                                                                                     value={modality2}>
                                                                            <Space direction="vertical">
                                                                                {
                                                                                    subjectData.filter(subject => subject.order === 1 && subject.modality === modality)
                                                                                        .map(subject => <Radio
                                                                                           key={subject.id} value={subject.id}>{subject.subject}</Radio>)
                                                                                }
                                                                            </Space>
                                                                        </Radio.Group>
                                                                    </>
                                                                }
                                                                {
                                                                    modality && modality2 && <>
                                                                        <p dangerouslySetInnerHTML={{__html: t("tek3")}} />
                                                                        <Checkbox.Group style={{marginTop: 5, marginBottom: 10}}
                                                                                        onChange={changeModality3}
                                                                                        value={modality3}>
                                                                            <Space direction="vertical">
                                                                                {
                                                                                    subjectData.filter(subject => subject.order === 2 && subject.modality === modality)
                                                                                        .map(subject => <Checkbox
                                                                                            disabled={isDisabledCheck(subject)}
                                                                                            value={subject.id}>{subject.subject}</Checkbox>)
                                                                                }
                                                                            </Space>
                                                                        </Checkbox.Group>
                                                                    </>
                                                                }
                                                                {
                                                                    modality && modality2 && modality3 && modality3.length > 1 && <>
                                                                        <p>{t("tek4")}</p>

                                                                        <Radio.Group style={{marginTop: 5, marginBottom: 10}}
                                                                                     value={modality4}
                                                                                     onChange={changeModality4}>
                                                                            <Space direction="vertical">
                                                                                {
                                                                                    subjectData.filter(subject => subject.order === 3 && subject.modality === modality)
                                                                                        .map(subject => <Radio
                                                                                            key={subject.id} value={subject.id}>{subject.subject}</Radio>)
                                                                                }
                                                                            </Space>
                                                                        </Radio.Group>
                                                                    </>}
                                                            </div>
                                                        </>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                        <div className={"question__content-bottom"}>
                                            <div className="left">
                                                
                                                    <Button onClick={() => goBack()}
                                                            type={"link"}
                                                            className="btnPrimaryWhite"
                                                    >
                                                        {t("atras")}
                                                    </Button>
                                                
                                            </div>
                                            <div className="right">
                                                <Button onClick={() => saveResponse()}
                                                        disabled={disabled}
                                                        type={"primary"}
                                                        className="primaryButton"
                                                >
                                                    {t("continuar")}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>

            </div>
    )
}

export default withTranslation()(StartTekPage);
